import { NavigationGuard } from 'vue-router'

import { setLocale, supportedLocale, DEFAULT_LOCALE } from '@/i18n'
import store from '@/store'

export const authenticationGuard: NavigationGuard = async (to, from, next) => {
  const isAuthenticated = store.getters['profile/isAuthenticated']

  // If is authenticated or navigating to login
  if (isAuthenticated()) {
    return next()
  }

  // Navigate to login if not authenticated
  next({ name: 'login', params: { next: to.fullPath } })
}


/**
 * Checks that a locale param is passed and if not assigns
 * the locale param to the previous routes locale or the default of 'en'.
 */
export const localeGuard: NavigationGuard = (to, from, next) => {
  let locale = to.params.locale

  // If no locale was passed, set to the previous locale
  // so we do not have to manually set locale.
  if (!supportedLocale(locale)) {
    // Assign to the previous locale
    locale = from.params.locale
    to.params.locale = supportedLocale(locale) ? locale : DEFAULT_LOCALE
    return next(to)
  }

  // Set the current locale for i18n
  setLocale(locale)

  next()
}
